import React from 'react';
import styled from 'styled-components';
import { colors } from 'Constants';

import { Container } from 'Components/core';

const Tab = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
  width: 100%;
 padding:5px;
 padding-top:10px;
 padding-bottom:10px;
 
  
  background-color: ${props =>
    //props.active ? colors.accent : colors.accentLight
    props.active ? '#081f65' : '#182f85'
    };
  ${props =>  true  &&`color: ${colors.textOnAccent};`}
  cursor: pointer;
  font-size: 1.0em;
  user-select: none;

  .triangle {
    position: absolute;
    ${props => !props.active && 'display: none;'}
    fill: #081f65;//${colors.accent};
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
  }
`;

export default props => [
  <Tab onClick={props.onClick} active={props.active}>
    <svg height="50" width="50" className="triangle">
      <polygon points="0,0 25,25 50,0" />
    </svg>
     <span dangerouslySetInnerHTML={{__html:props.header}}></span>
  </Tab>
];
